import React from 'react';
import './Popup.css';

const Popup = ({ children, onClose }) => {
  return (
    <div className="popup-overlay">
      <div className="popup">
        <h2>{/* dynamic title can go here */}</h2>
        {children}
      </div>
    </div>
  );
};

export default Popup;
